module.exports = __webpack_public_path__ + "img/paper-plane-grey.cdc697a6.svg";